export const textKeys = {
    headerTitle: "activation.bt.widget.title",
    headerButtonText: "activation.bt.widget.navigation.button.text",
    versusTooltipText: "activation.bt.widget.header.versus.tooltip.title",
    versusLabelText: "project.preview.header.text.versus",
    momChange: "benchmark.report.bar.chart.title.MoM",
    wowChange: "benchmark.report.bar.chart.title.WoW",
    yoyChange: "benchmark.report.bar.chart.title.YoY",
    mom: "common.mom",
    wow: "common.wow",
    yoy: "common.yoy",
    bodyHeader: "activation.home.widget.header.title.text",
    others: "bt.metrics.share.cell.others",
    domain: "common.domain",
    trafficShare: "activation.home.widget.body.table.column.traffic",

};
